// Container.tsx
import React, { FC, useContext, ReactNode } from "react";
import {
  ApplicationRootStyle,
  ComponentsAndHeaderRootStyles,
  Main,
} from "./container.styled";
import Header from "core/components/layout/header/header";
import Footer from "core/components/layout/footer/footer";
import Dashboard from "core/components/layout/dashboards/standard/dashboard";
import { SidebarProvider } from "core/contexts/sidebar/sidebar";
import { AuthContext } from "core/contexts/auth/auth";
import SidebarMenu from "../sidebar/sidebar";

interface ContainerProps {
  children: ReactNode;
}

const Container: FC<ContainerProps> = ({ children }) => {
  const { afUser } = useContext(AuthContext);

  return (
    <ApplicationRootStyle>
      <SidebarProvider>
        <Main>
          <SidebarMenu />
          <ComponentsAndHeaderRootStyles>
            {/* As the sidebar is a dynamic width element, it has been decided it spans to the top: 0px */}
            <Header />
            <Dashboard name={afUser?.given_name || ""}>{children}</Dashboard>
          </ComponentsAndHeaderRootStyles>
        </Main>
        <Footer />
      </SidebarProvider>
    </ApplicationRootStyle>
  );
};

export default Container;
